module.exports = __webpack_public_path__ + "img/overseas_2.c55c5de5.jpg";